import { render, staticRenderFns } from "./direct-form.vue?vue&type=template&id=1e4cb86c&scoped=true&"
import script from "./direct-form.vue?vue&type=script&lang=js&"
export * from "./direct-form.vue?vue&type=script&lang=js&"
import style0 from "./direct-form.vue?vue&type=style&index=0&id=1e4cb86c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e4cb86c",
  null
  
)

export default component.exports